module.exports = __webpack_public_path__ + "img/nav-partnership.80bfd8c.png";